export default __webpack_public_path__ + "static/location01-103c97d659ad8f68b092f6fd367c070c.png";